<template>
  <div class="wizard-card">
    <h2 v-if="title" class="intro">
      {{ title }}
    </h2>
    <p v-if="intro" class="intro">
      {{ intro }}
    </p>
    <div class="topics">
      <wizard-teaser-mini
        v-for="(topic, i) in topics"
        :key="i"
        class="mini-teaser"
        :item="topic"
        @cardClicked="$emit('cardClicked', topic)"
      />
    </div>
  </div>
</template>

<script>
import WizardTeaserMini from './WizardTeaserMini'

export default {
  name: 'WizardCard',
  components: { WizardTeaserMini },
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.wizard-card {
  h2 {
    color: var(--c-primary-neutral-3);
    margin-bottom: 15px;
  }

  p {
    font-weight: 400;
    font-style: normal;
    font-size: 15px;
    line-height: 1.35;
    color: var(--c-primary-neutral-3);
  }

  .topics {
    display: flex;
    flex-direction: column;
    margin: 20px -15px 0;

    .mini-teaser {
      cursor: pointer;
      margin-bottom: 2vh;
    }
  }

  @media (--sm) {
    .topics {
      flex-wrap: wrap;
      flex-direction: row;

      .mini-teaser {
        width: 46%;

        &:nth-child(2n-1) {
          margin-right: 2vh;
        }
      }
    }
  }
}
</style>
